// Payees table headers (similar to tenant table headers)
export const payeeTableHeaders = [
  { Header: "S.No" },
  { Header: "Name" },
  { Header: "Email" },
  { Header: "Mobile" },
  { Header: "Role" },
  { Header: "Verification Status" },
  { Header: "Actions" },
];

// Payees table column definitions
export const payeesColumnsData = [
  {
    Header: "S.No",
    accessor: "serialNumber",
  },
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Email",
    accessor: "Email",
  },
  {
    Header: "Mobile",
    accessor: "MobileNumber",
  },
  {
    Header: "Role",
    accessor: "Role",
  },
  {
    Header: "Type",
    accessor: "Type",
  },
  {
    Header: "Bank Details",
    accessor: "bankDetails",
  },
  {
    Header: "Verification Status",
    accessor: "VerificationStatus",
  },
  {
    Header: "Last Updated",
    accessor: "UpdatedAt",
  },
];

// Verification status options
export const verificationStatusOptions = [
  { value: "all", label: "All Statuses" },
  { value: "verified", label: "Verified" },
  { value: "pending", label: "Pending" },
  { value: "rejected", label: "Rejected" },
  { value: "not_initiated", label: "Not Initiated" },
];

// Role options
export const roleOptions = [
  { value: "all", label: "All Roles" },
  { value: "admin", label: "Admin" },
  { value: "property_owner", label: "Property Owner" },
];

// Type options
export const typeOptions = [
  { value: "all", label: "All Types" },
  { value: "investor", label: "Investor" },
  { value: "standard", label: "Standard" },
];
